import {
  ReflectionTopicsDrawerControlMenuItem,
  ReflectionTopicsDrawerControls,
} from './ReflectionTopicsDrawerControls';
import type {
  ReflectionTopicsDrawerControlMenuItemProps,
  ReflectionTopicsDrawerControlsProps,
} from './ReflectionTopicsDrawerControls';
import { useReflectionTopicsDrawerControl } from './useReflectionTopicsDrawerControl';

export function ReflectionTopicsDrawerControlsWrapper(
  props: Pick<ReflectionTopicsDrawerControlsProps, 'className' | 'drawerId'>,
) {
  const { helperText, isDrawerOpen, onClick, shouldShowButton } = useReflectionTopicsDrawerControl();

  return shouldShowButton ? (
    <ReflectionTopicsDrawerControls {...props} isDrawerOpen={isDrawerOpen} onClick={onClick} tooltipText={helperText} />
  ) : null;
}

export function ReflectionTopicsDrawerControlMenuItemWrapper(
  props: Pick<ReflectionTopicsDrawerControlMenuItemProps, 'className' | 'drawerId'>,
) {
  const { helperText, isDrawerOpen, onClick, shouldShowButton } = useReflectionTopicsDrawerControl();

  return shouldShowButton ? (
    <ReflectionTopicsDrawerControlMenuItem
      {...props}
      helperText={helperText}
      isDrawerOpen={isDrawerOpen}
      onClick={onClick}
    />
  ) : null;
}
